import { useDispatch } from "react-redux";
import * as Yup from "yup";
import { Modal } from "flowbite-react";
import { useFormikWrapper } from "../../../../components/formik_wrapper";
import * as actions from "../../../../actions";
import { FlatButton } from "../../../../components/buttons";
import { TextBox } from "../../../../components/inputs";

function FleetSetupModal({ company_uid, isOpen, onClose }) {
  const dispatch = useDispatch();

  const setupForm = useFormikWrapper({
    initialValues: {
      user_name: "",
      password: "",
    },
    validationSchema: Yup.object({
      user_name: Yup.string().required("Azuga Username is required"),
      password: Yup.string().required("Azuga Password is required"),
    }),
    onSubmit: () => {
      dispatch(
        actions.ADD_FLEET_AUTH_REQ({
          company_uid,
          user_name: setupForm.values.user_name,
          password: setupForm.values.password,
        })
      );
    },
  });

  const handleCancel = () => {
    setupForm.resetForm();
    onClose();
  };

  return (
    <Modal show={isOpen} size="md" onClose={handleCancel}>
      <Modal.Header className="px-3 pt-3">Setup Zuper Fleet</Modal.Header>
      <Modal.Body className="p-3">
        <div className="relative px-2.5 overflow-visible text-gray-700 space-y-4">
          <TextBox
            formik={setupForm}
            name="user_name"
            label="Azuga Username"
            placeholder="Azuga Username"
          />
          <TextBox
            formik={setupForm}
            name="password"
            label="Azuga Password"
            type="password"
            placeholder="Azuga Password"
          />
        </div>
      </Modal.Body>
      <Modal.Footer className="p-3">
        <div className="flex w-full justify-end gap-4 px-2.5">
          <FlatButton
            appearance="secondary"
            className="w-[100px]"
            onClick={handleCancel}
          >
            Cancel
          </FlatButton>
          <FlatButton
            appearance="primary"
            className="w-[100px]"
            onClick={() => setupForm.submitForm()}
          >
            Connect
          </FlatButton>
        </div>
      </Modal.Footer>
    </Modal>
  );
}

export default FleetSetupModal;
